import { Button } from '@navi/web-ui/lib/primitives';

interface RetriggerAllocationsButtonProps {
  onClick: () => void;
}

const RetriggerAllocationsButton = ({ onClick }: RetriggerAllocationsButtonProps) => {
  return (
    <Button onClick={onClick} variant="primary" className="w-[140px]">
      Retrigger
    </Button>
  );
};

export default RetriggerAllocationsButton;
